import React, {useState} from "react";

import styles from "./Button.module.css"
import classnames from "classnames";

export enum ButtonState {
    PRIMARY,
    SECONDARY,
    DISABLED
}

interface ButtonProps {
    title: string
    secondTitle?: string
    resetSeconds?: number
    iconSrc?: string
    state: ButtonState
    handleClick: () => void
}

export const Button: React.FC<ButtonProps> = ({
                                                  title,
                                                  secondTitle,
                                                  resetSeconds = 2,
                                                  iconSrc,
                                                  state,
                                                  handleClick
                                              }) => {

    const [buttonText, setButtonText] = useState(title);

    const getWrapperStyles = () => {
        switch (state) {
            case ButtonState.SECONDARY:
                return styles.secondaryWrapper
            case ButtonState.DISABLED:
                return styles.disabledWrapper
            default:
                return styles.primaryWrapper
        }
    }

    const getTitleStyles = () => {
        switch (state) {
            case ButtonState.SECONDARY:
                return styles.secondaryTitle
            case ButtonState.DISABLED:
                return styles.disabledTitle
            default:
                return styles.primaryTitle
        }
    }

    const handleButtonClick = () => {
        if (state !== ButtonState.DISABLED) {
            handleClick()
            if (secondTitle) {
                setButtonText(secondTitle);
                setTimeout(() => setButtonText(title), resetSeconds * 1000);
            }
        }
    }

    return <div className={classnames(getWrapperStyles(), styles.wrapper)} onClick={() => handleButtonClick()}>
        {iconSrc && <img src={iconSrc} alt={"icon"}/>}
        <span className={getTitleStyles()}>{buttonText}</span>
    </div>
}
